import { render } from "./the-header.vue?vue&type=template&id=6f84760f&ts=true"
import script from "./the-header.vue?vue&type=script&lang=ts"
export * from "./the-header.vue?vue&type=script&lang=ts"

import "./the-header.vue?vue&type=style&index=0&id=6f84760f&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__